import * as React from 'react';
import { useState } from 'react';
import V4TabList from './v4TabList';
import V4Video from './v4Video';
import V4Question from './v4Question';
import V4Warning from './v4Warning';
import { AccVideoDetailResultVO } from '@domain/vo/acca/v1/test/result/apply/AccVideoResultVO';
import classNames from 'classnames/bind';
import styles from './v4Check.module.scss';

const cx = classNames.bind(styles);

const V4Check = () => {
  const [videoDetailTab, setVideoDetailTab] = useState<AccVideoDetailResultVO | null>(null);
  const [openedSubTab, setOpenedSubTab] = useState<AccVideoDetailResultVO | null>(null);

  return (
    <>
      <em className={cx('title')}>내 영상 확인하기</em>

      <div className={cx('v4CheckArea')}>
        {/* [D] 탭 영역 */}
        <V4TabList
          videoDetailTab={videoDetailTab}
          setVideoDetailTab={setVideoDetailTab}
          openedSubTab={openedSubTab}
          setOpenedSubTab={setOpenedSubTab}
        />

        <div className={cx('v4CheckAreaWrap')}>
          {/* [D] 영상 영역 */}
          <V4Video url={videoDetailTab?.url} />

          {/* [D] 질문 영역 */}
          <V4Question videoDetailTab={videoDetailTab} />

          {/* [D] 경고 영역 */}
          <V4Warning videoDetailTab={videoDetailTab} />
        </div>
      </div>
    </>
  );
};

export default V4Check;
